/**
 * Hold PDP rating height, then show "No reviews yet" if Reviews.io stays empty.
 * Clicking stars opens the Polaris reviews widget in a modal.
 */
(function (root) {
  'use strict';
  var MAX_ATTEMPTS = 12;
  var INTERVAL_MS = 150;
  var SLOT_SEL = '.product__info-container .d1-pdp-rating-slot';
  var BLOCK_SEL = '.product__info-container .shopify-block:has(.ruk_rating_snippet)';
  var WIDGET_SEL = '.reviews-io-polaris-widget, [id*="ReviewsWidget"], [id*="reviewsio_polaris"]';
  var MODAL_ID = 'd1-reviews-modal';
  var lastTrigger = null;
  var modalOpen = false;

  function ratingBlocks() {
    var slots = document.querySelectorAll(SLOT_SEL);
    if (slots.length) return slots;
    return document.querySelectorAll(BLOCK_SEL);
  }

  function childCount(el) {
    return el && el.childElementCount ? el.childElementCount : 0;
  }

  function shouldShowFallback(count, attempt) {
    if (count > 0) return false;
    return attempt >= MAX_ATTEMPTS;
  }

  function emptyCopy() {
    var copy = root.D1_NO_REVIEWS_YET;
    if (!copy || /translation missing/i.test(String(copy))) return 'No reviews yet';
    return copy;
  }

  function ensureFallback(block) {
    var el = block.querySelector('[data-d1-pdp-rating-fallback]');
    if (el) return el;
    el = document.createElement('p');
    el.className = 'd1-pdp-rating__fallback caption';
    el.setAttribute('data-d1-pdp-rating-fallback', '');
    el.textContent = emptyCopy();
    el.hidden = true;
    block.appendChild(el);
    return el;
  }

  function settle(attempt) {
    var blocks = ratingBlocks();
    var stillEmpty = false;
    for (var i = 0; i < blocks.length; i++) {
      var snippet = blocks[i].querySelector('.ruk_rating_snippet');
      var fallback = ensureFallback(blocks[i]);
      var count = childCount(snippet);
      if (count > 0) {
        fallback.hidden = true;
        continue;
      }
      if (shouldShowFallback(count, attempt)) fallback.hidden = false;
      else stillEmpty = true;
    }
    if (stillEmpty && attempt < MAX_ATTEMPTS) {
      setTimeout(function () {
        settle(attempt + 1);
      }, INTERVAL_MS);
    }
  }

  function findWidget() {
    return document.querySelector(WIDGET_SEL);
  }

  function isReviewsTrigger(node) {
    if (!node || typeof node.closest !== 'function') return false;
    if (node.closest('.d1-reviews-modal')) return false;
    if (node.closest('[data-d1-pdp-rating-fallback]')) return false;
    return !!(
      node.closest('.product__info-container') &&
      node.closest('.ruk_rating_snippet, .d1-pdp-rating-slot')
    );
  }

  function copy(key, fallback) {
    var value = root[key];
    if (!value || /translation missing/i.test(String(value))) return fallback;
    return value;
  }

  function el(tag, className) {
    var node = document.createElement(tag);
    if (className) node.className = className;
    return node;
  }

  function ensureModal() {
    var existing = document.getElementById(MODAL_ID);
    if (existing) return existing;

    var rootEl = el('div', 'd1-reviews-modal');
    rootEl.id = MODAL_ID;
    rootEl.setAttribute('aria-hidden', 'true');

    var overlay = el('div', 'd1-reviews-modal__overlay');
    overlay.setAttribute('data-d1-reviews-close', '');

    var dialog = el('div', 'd1-reviews-modal__dialog');
    dialog.setAttribute('role', 'dialog');
    dialog.setAttribute('aria-modal', 'true');
    dialog.setAttribute('aria-labelledby', 'd1-reviews-modal-title');

    var bar = el('div', 'd1-reviews-modal__bar');
    var title = el('h2', 'd1-reviews-modal__title');
    title.id = 'd1-reviews-modal-title';
    title.textContent = copy('D1_REVIEWS_MODAL_TITLE', 'Reviews');

    var closeBtn = el('button', 'd1-reviews-modal__close');
    closeBtn.type = 'button';
    closeBtn.setAttribute('data-d1-reviews-close', '');
    closeBtn.setAttribute('aria-label', copy('D1_REVIEWS_MODAL_CLOSE', 'Close reviews'));
    var closeIcon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
    closeIcon.setAttribute('width', '16');
    closeIcon.setAttribute('height', '16');
    closeIcon.setAttribute('viewBox', '0 0 16 16');
    closeIcon.setAttribute('aria-hidden', 'true');
    var closePath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
    closePath.setAttribute('d', 'M3.2 3.2l9.6 9.6M12.8 3.2l-9.6 9.6');
    closePath.setAttribute('fill', 'none');
    closePath.setAttribute('stroke', 'currentColor');
    closePath.setAttribute('stroke-width', '1.8');
    closePath.setAttribute('stroke-linecap', 'round');
    closeIcon.appendChild(closePath);
    closeBtn.appendChild(closeIcon);

    var body = el('div', 'd1-reviews-modal__body');
    body.setAttribute('data-d1-reviews-body', '');

    bar.appendChild(title);
    bar.appendChild(closeBtn);
    dialog.appendChild(bar);
    dialog.appendChild(body);
    rootEl.appendChild(overlay);
    rootEl.appendChild(dialog);
    document.body.appendChild(rootEl);

    rootEl.addEventListener('click', function (event) {
      if (event.target.closest('[data-d1-reviews-close]')) closeModal();
    });
    return rootEl;
  }

  function adoptWidget() {
    var widget = findWidget();
    var body = document.querySelector('[data-d1-reviews-body]');
    if (!widget || !body || widget.parentElement === body) return widget;
    var host = widget.closest('.shopify-section');
    if (host) host.setAttribute('data-d1-reviews-host', '');
    body.appendChild(widget);
    return widget;
  }

  function openModal() {
    if (!findWidget()) return false;
    var modal = ensureModal();
    adoptWidget();
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('d1-reviews-modal-open');
    modalOpen = true;
    var closeBtn = modal.querySelector('.d1-reviews-modal__close');
    if (closeBtn) closeBtn.focus();
    return true;
  }

  function closeModal() {
    var modal = document.getElementById(MODAL_ID);
    if (!modal) return;
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('d1-reviews-modal-open');
    modalOpen = false;
    if (lastTrigger && typeof lastTrigger.focus === 'function') lastTrigger.focus();
  }

  function onTriggerClick(event) {
    if (!isReviewsTrigger(event.target)) return;
    if (!findWidget()) return;
    lastTrigger =
      event.target.closest('a, button, .ruk_rating_snippet, .d1-pdp-rating-slot') || event.target;
    event.preventDefault();
    event.stopPropagation();
    openModal();
  }

  function onKeydown(event) {
    if (event.key === 'Escape' && modalOpen) {
      event.preventDefault();
      closeModal();
    }
  }

  function bindReviewsModal() {
    document.addEventListener('click', onTriggerClick, true);
    document.addEventListener('keydown', onKeydown);
    if (
      typeof location !== 'undefined' &&
      (location.hash === '#d1-reviews-modal' || /ReviewsWidget/i.test(String(location.hash)))
    ) {
      openModal();
    }
  }

  // Reviews.io's app embed only calls ratingSnippet() on window "load", which waits for every
  // image/chat script (~3s). The library is ready much sooner, so start it as soon as it exists.
  // Re-running ratingSnippet() on the same element is idempotent, so the app's later call is harmless.
  // Options mirror the app embed (rating-snippet block); keep in sync if its settings change.
  var EARLY_INIT_INTERVAL_MS = 50;
  var EARLY_INIT_MAX_ATTEMPTS = 100;

  function ratingSnippetOptions() {
    return {
      store: root.reviewsIoStore || (root.Shopify && root.Shopify.shop),
      color: '#2369FF',
      textClr: '#333333',
      linebreak: false,
      listenForChanges: true,
      text: 'Reviews',
      lang: root.reviewsIoLang || 'en',
      mode: 'default',
      showEmptyStars: false,
      anchorToReviewsWidget: true,
      enableSyndication: !!root.reviewsIoEnableSyndication,
    };
  }

  function initRatingEarly(attempt) {
    var options = ratingSnippetOptions();
    if (typeof root.ratingSnippet === 'function' && options.store) {
      root.ratingSnippet('ruk_rating_snippet', options);
      return;
    }
    if (attempt < EARLY_INIT_MAX_ATTEMPTS) {
      setTimeout(function () {
        initRatingEarly(attempt + 1);
      }, EARLY_INIT_INTERVAL_MS);
    }
  }

  function start() {
    bindReviewsModal();
    if (!ratingBlocks().length) return;
    initRatingEarly(0);
    settle(0);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }

  root.D1PdpRating = {
    shouldShowFallback: shouldShowFallback,
    emptyCopy: emptyCopy,
    isReviewsTrigger: isReviewsTrigger,
    findWidget: findWidget,
    openModal: openModal,
    closeModal: closeModal,
    MAX_ATTEMPTS: MAX_ATTEMPTS,
    ratingSnippetOptions: ratingSnippetOptions,
  };
})(typeof window !== 'undefined' ? window : globalThis);
